import Flickity from 'flickity';
import mixitup from 'mixitup';

if(document.querySelector('.faq-carousel')) {
// Flickity
    var flkty = new Flickity('.faq-carousel', {
        cellAlign:       'left',
        groupCells:      true,
        contain:         true,
        wrapAround:      true,
        pageDots:        true,
        prevNextButtons: false
    });
}

if(document.querySelector('.faq-overview')) {
    const mixer = mixitup('.faq-overview', {
        selectors: {
            target: '.faq-item'
        },
        controls:  {
            enable: false
        },
        animation: {
            animateResizeContainer: false,
            effects:                'fade scale',
            duration:               300
        }
    });

    const updateFilter = () => {
        const searchQuery = document.querySelector('[name="filter_search"]').value;

        let filtered = Array.from(document.querySelectorAll('.faq-item')).filter((target) => {
            let regex = new RegExp(searchQuery.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$]/g, "\\$&"), 'gi');
            return target.getAttribute('data-search').match(regex);
        });

        mixer.filter(filtered);
    }

    const filterSearch = document.querySelector('[name="filter_search"]');
    filterSearch.addEventListener('input', function() {
        updateFilter();
    });
}

$(document).ready(function() {
    resize();
    addClasses();

    if($('.has-error').length > 0) {
        var yOffset = -150;
        var element = $('.has-error').get(0);
        var y       = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    if($('.alert-danger').length > 0) {
        var yOffset = -150;
        var element = $('.alert-danger').get(0);
        var y       = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    if($('.clickable').length > 0) {
        $('.clickable').click(function() {
            if($('a', $(this)).length > 0) {
                window.location = $('a', $(this)).attr('href');
            }
        });
    }

    if($('nav.navbar').length > 0) {

        $('nav.navbar .dropdown').click(function() {
            if($(window).width() > 768) {
                window.location = $('a', this).attr('href');
            }
        });
    }

    if($('a.dropdown-toggle').length > 0) {
        $('a.dropdown-toggle').click(function(e) {
            //e.preventDefault();
            //return false;
        });
    }

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween: 8
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {

        if(window.cubeRAF) {

            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;

        }

    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {

        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }

    });

    modulobox.init();

    // Interact with Map once the user has clicked (to prevent scrolling the page = zooming the map
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Countdown Timer
    if($('.countdown').length) {
        $('.countdown').each(function() {
            var date = $(this).attr('data-date');
            $(this).countdown(date, function(event) {
                $(this).text(
                    event.strftime('%D')
                );
            });
        });
    }

    // OWL carousel
    if($('.owl-carousel').length > 0) {
        $('.owl-carousel').owlCarousel({
            nav:        false,
            loop:       true,
            margin:     2,
            responsive: {
                0:    {
                    items: 1
                },
                600:  {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        });
    }

    if($('.owl-carousel-large').length > 0) {
        $('.owl-carousel-large').owlCarousel({
            nav:        false,
            loop:       true,
            margin:     2,
            responsive: {
                0:    {
                    items: 2
                },
                600:  {
                    items: 5
                },
                1000: {
                    items: 6
                }
            }
        });
    }

    if($('table').length > 0) {
        $('table').each(function() {
            if(!$(this).parent().hasClass('table-responsive')) {
                $(this).addClass('table table-striped').wrap('<div class="table-responsive"></div>');
            }
        });
    }

    if($('.programmeCarousel').length > 0) {

        // var $singleProgrammeCarousel = $('.singleProgrammeCarousel').owlCarousel( {
        // 	nav: false,
        // 	loop: true,
        // 	callbacks: true,
        // 	responsive: {
        // 		0: {
        // 			items:1
        // 		}
        // 	}
        // } );

        //var currItem = 0;

        var $programmeCarousel = $('.programmeCarousel').on('initialize.owl.carousel', function(event) {
            //$singleProgrammeCarousel.trigger('to.owl.carousel', [(event.item.index-1),150,true]);
            //currItem = (event.item.index-1)
        }).owlCarousel({
            nav:        false,
            dots:       true,
            dotsEach:   true,
            loop:       true,
            callbacks:  true,
            responsive: {
                0:    {
                    items: 2
                },
                1000: {
                    items: 3
                }
            }
        });

        $('.nextProgramme').click(function() {
            $programmeCarousel.trigger('next.owl.carousel');
            // currItem++;
            // $singleProgrammeCarousel.trigger('to.owl.carousel', [currItem,150,true]);
        });

        $('.prevProgramme').click(function() {
            $programmeCarousel.trigger('prev.owl.carousel');
            // currItem--;
            // $singleProgrammeCarousel.trigger('to.owl.carousel', [currItem,150,true]);
        });

        /*$programmeCarousel.on('change.owl.carousel', function(event) {
            $singleProgrammeCarousel.trigger('to.owl.carousel', [(event.item.index+1),150,true]);
        } );*/
    }

    //Grid.init();

    if($('#instafeed').length > 0) {
        var userFeed = new Instafeed({
            get:         'user',
            userId:      '1835557323',
            clientId:    '063796d95d5d47a592bb1ee8b89e532a',
            accessToken: '1835557323.1677ed0.12554e181b0b4da19502ff83a2e3aeb4',
            resolution:  'standard_resolution',
            template:    '<a href="{{link}}" target="_blank" id="{{id}}"><img src="/img/square.png" class="instapic" style="background:url({{image}}) center center no-repeat; background-size:cover;" /></a>',
            sortBy:      'most-recent',
            limit:       5,
            links:       false
        });
        userFeed.run();
    }

});

$(window).load(function() {
    resize();
    addClasses();

    if($('.programme.home').length > 0) {
        var h = $('.programme.home .programme').get(0).scrollHeight;
        $('.programme.home .side').css({
            height: h + 'px'
        });
    }

    if($('.same-height').length > 0) {
        var height = 0;
        $('.same-height').each(function(i) {
            if($(this).height() > height) {
                height = $(this).height();
            }
        });

        $('.same-height').height(height);
    }
});

$(window).resize(function() {
    resize();
    addClasses();
});

$(window).scroll(function() {
    if($('.navigation.top').length > 0) {
        if(!$('body').hasClass('device-xs')) {
            if($(document).scrollTop() > 10) {
                $('.navigation.top').addClass('smaller');
            } else {
                $('.navigation.top').removeClass('smaller');
            }
        }
    }
});

function resize() {
}


function addClasses() {
    var windowWidth = window.innerWidth;

    if(windowWidth >= 1200) {
        $('body').removeClass('device-xs');
        $('body').removeClass('device-sm');
        $('body').removeClass('device-md');
        if(!$('body').hasClass('device-lg')) {
            $('body').addClass('device-lg');
        }
    } else if(windowWidth < 1200 && windowWidth >= 992) {
        $('body').removeClass('device-xs');
        $('body').removeClass('device-sm');
        $('body').removeClass('device-lg');
        if(!$('body').hasClass('device-md')) {
            $('body').addClass('device-md');
        }
    } else if(windowWidth < 992 && windowWidth >= 768) {
        $('body').removeClass('device-xs');
        $('body').removeClass('device-md');
        $('body').removeClass('device-lg');
        if(!$('body').hasClass('device-sm')) {
            $('body').addClass('device-sm');
        }
    } else if(windowWidth < 768) {
        $('body').removeClass('device-sm');
        $('body').removeClass('device-md');
        $('body').removeClass('device-lg');
        if(!$('body').hasClass('device-xs')) {
            $('body').addClass('device-xs');
        }
    }
}

/*]]>*/
